import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-communication',
  templateUrl: './add-communication.component.html',
  styles: []
})
export class AddCommunicationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
